import {isRejectedWithValue, Middleware, MiddlewareAPI} from "@reduxjs/toolkit";
import {logOut} from "../../_fri/utils/function";

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
        const {payload, meta} = action;
        const status = (payload as { status?: number }).status;
        const endpoint = (meta as { arg?: {endpointName?: string} }).arg?.endpointName;
        const unprotectedEndpoints = ["credentials", "forgotPassword", "recoverPassword"];

        const shouldLogOut = status === 401 && !unprotectedEndpoints.includes(endpoint||'')

        if (shouldLogOut) {
            logOut()
        }


    }

    return next(action);
};
